import { dequeueItem } from "../store/screenGrabSlice";
import { useCreateBlobMutation } from "services/blobStorage";
import useQueueProcessor from "./useQueueProcessor";
import { handleError } from "helpers/sentry";
import { ClientErrorTypes } from "globals/enums";

const useScreenGrabUploader = () => {
  const [createBlob] = useCreateBlobMutation();
  const queueSelector = (state: any) => state.screenGrabQueue;

  const uploadAction = async (item: any) => {
    try {
      await createBlob(item).unwrap();
    } catch (error) {
      handleError(error, ClientErrorTypes.ScreenGrabUploadError, {
        upload_url: item?.url,
        alert_type_id: item?.alert_type_id,
        captured_at: item?.captured_at,
      });
    }
  };

  const uploadError = (error: unknown) => {
    handleError(error, ClientErrorTypes.ScreenGrabUploadError);
  };

  useQueueProcessor(queueSelector, dequeueItem, uploadAction, uploadError);
};

export default useScreenGrabUploader;
